import { SelectionState } from 'draft-js';

export const findLinkRange = (block, contentState, selection) => {
  let linkRange = null;

  block.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === 'LINK'
      );
    },
    (start, end) => {
      const startOffset = selection.getStartOffset();

      if (startOffset >= start && startOffset <= end) {
        const blockKey = block.getKey();

        linkRange = new SelectionState({
          anchorKey: blockKey,
          anchorOffset: start,
          focusKey: blockKey,
          focusOffset: end,
        });
      }
    }
  );

  return linkRange;
};
